<template>
  <div class="item-card">
    <router-link class="image-search-link" :to="'/items/' + item.imdbID + '?listId=' + listId">
      <img v-bind:src="item.Poster" class="float-left" />
    </router-link>
    <div class="search-item-body">
      <h3 class="mb-1">{{ item.Title }}</h3>
      <span>{{ item.Year }}</span>
      <div class="search-action-buttons">
        <router-link
          :to="'/items/' + item.imdbID + '?listId=' + listId"
          class="btn btn-yellow btn-view-movie"
          :aria-label="'View ' + item.Title"
          :title="'View ' + item.Title">
          <i class="fa fa-search" aria-hidden="true"></i>
          <span>View</span>
        </router-link>
        <button
          type="button"
          class="btn btn-add-movie add-state-button"
          :class="addButtonClass"
          :disabled="addDisabled"
          :aria-label="addButtonAriaLabel"
          :data-testid="'add-item-' + item.imdbID"
          @click="addItem">
          <i :class="addButtonIcon" aria-hidden="true"></i>
          <span>{{ addButtonText }}</span>
        </button>
        <button
          v-if="item.isInList && canRemove"
          type="button"
          @click="removeItem"
          class="btn btn-red btn-add-movie"
          :aria-label="'Remove ' + item.Title"
          :title="'Remove ' + item.Title">
          <i class="fa fa-minus-circle" aria-hidden="true"></i>
          <span>Remove</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchItem",
  props: {
    item: Object,
    listId: String,
    canRemove: Boolean,
    addState: {
      type: String,
      default: "default",
    },
  },
  emits: ["add-item", "remove-item"],
  methods: {
    addItem() {
      if (this.addDisabled) return;
      this.$emit("add-item", this.item);
    },
    removeItem() {
      this.$emit("remove-item", this.item);
    },
  },
  computed: {
    addButtonText() {
      return (
        {
          adding: "Adding…",
          added: "Added",
          already: "Already in list",
          failed: "Could not add",
        }[this.addState] || "Add"
      );
    },
    addButtonIcon() {
      return (
        {
          adding: "fa fa-spinner fa-spin",
          added: "fa fa-check-circle",
          already: "fa fa-check-circle",
          failed: "fa fa-exclamation-circle",
        }[this.addState] || "fa fa-plus-circle"
      );
    },
    addButtonClass() {
      return this.addState === "failed" ? "btn-red" : "btn-green";
    },
    addDisabled() {
      return this.addState === "adding" || this.addState === "added" || this.addState === "already";
    },
    addButtonAriaLabel() {
      return this.addState === "failed" ? "Retry adding " + this.item.Title : this.addButtonText + " " + this.item.Title;
    },
  },
};
</script>

<style scoped>
.movie-item-body {
  margin-left: 20px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.search-action-buttons {
  display: flex;
  flex-wrap: wrap;
  margin: auto 0 0 0;
}

.search-item-body {
  color: white;
  bottom: 12px;
}

.search-item-body {
  margin-left: 20px;
  flex-direction: column;
  display: flex;
  width: 100%;
}

.search-group .item-card h3 {
  font-size: 20px;
}

.search-item-body .btn {
  width: 100%;
  min-height: 45px;
  border-radius: 0;
  margin: 5px;
  font-size: 20px;
}

.search-item-body .btn-view-movie,
.search-item-body .btn-red:not(.add-state-button) {
  align-items: center;
  display: inline-flex;
  flex: 1 1 auto;
  gap: 7px;
  justify-content: center;
}

.add-state-button {
  align-items: center;
  display: inline-flex;
  gap: 7px;
  justify-content: center;
  white-space: nowrap;
}

.add-state-button:disabled {
  cursor: default;
  opacity: 0.8;
}
</style>
